import { render, staticRenderFns } from "./itemTalk.vue?vue&type=template&id=1ac8420c&scoped=true&"
import script from "./itemTalk.vue?vue&type=script&lang=js&"
export * from "./itemTalk.vue?vue&type=script&lang=js&"
import style0 from "./itemTalk.vue?vue&type=style&index=0&id=1ac8420c&prod&lange=scss&scoped=true&lang=css&"
import style1 from "./itemTalk.vue?vue&type=style&index=1&id=1ac8420c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac8420c",
  null
  
)

export default component.exports